import { BookingGetters } from "../../store/onlineBooking/getters";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
// import { createTheme, Theme, ThemeProvider } from "@mui/material/styles";
import createTheme from "@mui/material/styles/createTheme";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { formatTheme } from "../../config/MuiColorThemes";
import { getParentOrigin, allowedOrigins } from "../../helpers/iframeSource";

BasePageLayout.propTypes = {
  children: PropTypes.node,
  rootClasses: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  headerClasses: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  mainClasses: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  footerClasses: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};
export function BasePageLayout(props) {
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const appSettings = BookingGetters.getAppSettings();
  const isSmallScreen = window.innerWidth <= 768;
  useEffect(() => {
    const logoUrl = appSettings && appSettings["config"]?.logoUrl;
    const companyName = appSettings && appSettings["companyName"];
    if (companyName != null) {
      document.title = companyName;
    }
    if (logoUrl != null) {
      const icon =
        document.querySelector('link[rel="icon"]') ||
        document.createElement("link");
      icon.href = logoUrl;
      icon.rel = "icon";
      document.head.appendChild(icon);
    }
  }, [appSettings]);
  const parentOrigin = getParentOrigin();
  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";

  useEffect(() => {
    const hiddenPages = [
      "/choose/vehicle",
      "/signin",
      "/signin/",
      "/profile",
      "/changePassword",
      "/myReservedBookings",
      "/customerDetailsList",
      "/forgotpassword",
      "/updatePassword",
      "/signup",
      "/driverForm",
      "/anagraphData",
      "/anagraphData/",
      "/paymentData",
      "/myInvoices",
      "/myInvoices/",
    ];

    const event_id = hiddenPages.includes(window.location.pathname)
      ? "hideHomePageContent"
      : "showHomePageContent";

    window.parent.postMessage({ event_id }, targetOrigin);
  }, [window.location.pathname]);

  return (
    <ThemeProvider theme={dynamicTheme}>
      <div
        className={`min-h-screen flex flex-col bg-cover  ${
          props.rootClasses || ""
        }`}
      >
        <div className={`text-white`}>
          <main
            className={`grow bg-cover min-h-screen ${props.mainClasses}`}
            style={
              isSmallScreen
                ? { backgroundColor: "transparent" }
                : { backgroundColor: "transparent" }
            }
          >
            {props.children}
          </main>
        </div>
      </div>
    </ThemeProvider>
  );
}
